import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import FieldWithLabelAndValue from './atomic/FieldWithLabelAndValue';
import { isEmpty } from '../../../utils/transformValueUtils';
import { CART_STATUS } from '../../../types/cartStatuses';
import { HIGHLIGHT_STATUS } from '../../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
const STATUS_USE = {
  [CART_STATUS.ABANDONED]: 'candy-apple',
  [CART_STATUS.RECOVERED]: 'calypso',
  default: 'default'
};
const Status = ({
  value
}) => {
  const status = isEmpty(value) ? value : /*#__PURE__*/_jsx(UITag, {
    "data-test-id": HIGHLIGHT_STATUS,
    use: STATUS_USE[value] || STATUS_USE.default,
    inline: true,
    children: value
  });
  return /*#__PURE__*/_jsx(FieldWithLabelAndValue, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "highlightCard.propertyLabels.status"
    }),
    value: status
  });
};
export default Status;